import React from "react";
import styled from "styled-components";
import InfoIcon from "@material-ui/icons/Info";

const NoAccessMessageSpan = styled.span`
  margin: 10px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #9b71df;
  background: #f7f0ff;
  color: #545963;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const StyledInfoIcon = styled(InfoIcon)`
  color: #9b71df; // Same color as the border
`;

const NoAccessMessage = ({ children }) => (
  <NoAccessMessageSpan>
    <StyledInfoIcon />
    {children}
  </NoAccessMessageSpan>
);

export default NoAccessMessage;
